module.exports = __webpack_public_path__ + "img/left1.def1f8fc.png";